import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { forkJoin } from 'rxjs';
import { MessageNotificationType } from 'src/app/enum/message-notification-type';
import { BulkMessageService } from 'src/app/services/bulk-message.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import * as _ from "lodash";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import saveAs from 'file-saver';
import moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { NotificationService } from 'src/app/services/notification-service';
import { ExcelService } from 'src/app/services/excel.service';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { AdditionalFeaturesPopupComponent } from '../additional-features-popup/additional-features-popup.component';

@Component({
  selector: 'app-manage-push-notification',
  templateUrl: './manage-push-notification.component.html',
  styleUrls: ['./manage-push-notification.component.scss']
})
export class ManagePushNotificationComponent implements OnInit {




    serviceQueue = []
    tempindividualOrGroupList: any = [];
    tempnotificationTypeList: any = [];
    notificationTypeList: any = []
    individualOrGroupList: any = []
    messageList: any = [];
    data: any = []
    dataExcel: any = []
    dataSource = new MatTableDataSource(this.data);
    MessageNotificationTypeEnum = MessageNotificationType;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    hcmessageForm: FormGroup
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    filteredList1: any
    filteredList2: any
    toMinDate: any;
    toMaxDate: any;
    displayedColumns: string[] = [
        'MessagingType',
        'Recipient',
        'Status',
        'Action',
    ];
    excelColumns: string[];
    showfilter=false;
    constructor(private lookupDataService: LookupDataServiceService, private bulkMessageService: BulkMessageService, private navigation: NavigationService,
        private loaderService: LoaderService, private fb: FormBuilder, private toastr: NotificationService, private excelService: ExcelService,
        private matdialog:MatDialog
    ) { }

    ngOnInit() {
        this.loadServiceQueue();
        this.getTableData('')
        this.executeServiceQueue();
    }

    getTableData(data) {
        this.bulkMessageService.getPushMessageList(data).subscribe((results: any) => {
            this.messageList = results;
            this.data = results;
            this.dataExcel = results;
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }
    loadServiceQueue() {
        this.serviceQueue.push(this.lookupDataService.getIndividualOrGroup());
        this.serviceQueue.push(this.lookupDataService.getNotificationTypeList());
    }

    executeServiceQueue() {
        forkJoin(this.serviceQueue).subscribe((serviceResponse: any) => {
            this.tempindividualOrGroupList = serviceResponse[0];
            this.tempnotificationTypeList = serviceResponse[1]
            this.tempnotificationTypeList.forEach(item => {
                if (item.key == 2 || item.key == 3) {
                    this.notificationTypeList.push(item)
                    this.filteredList2 = this.notificationTypeList
                }
            });
            this.tempindividualOrGroupList.forEach(item => {
                if (item.key == 1 || item.key == 2) {
                    this.individualOrGroupList.push(item)
                    this.filteredList1 = this.individualOrGroupList
                }
            });
        });
    }
    
    Reset() {
        this.hcmessageForm.reset()
        this.getTableData('')
    }

    // addMessage() {
    //     // this.navigation.gotoMessage();
    //     // gotomessage add
    // }
    viewMail(message) {
        this.matdialog.open(AdditionalFeaturesPopupComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: 'mat-dialog',
            width: "30%",
            data: {
                title: 'Messaging Details',
                value:message
            }
        });
    }


    encryptionname(name: string): string {
      const nameParts = name.split(" ");
      let maskedName = nameParts.map(part => {
        if (part.length > 2) {
          return part.substring(0, 2) + 'xxx';
        } else {
          return part;
        }
      }).join(" ");
      return maskedName;
    }

    exportData(): void {
        this.loaderService.start();
        setTimeout(() => {
            var exportData = this.dataExcel;
            if (!exportData || exportData.length === 0) {
                this.toastr.showInfo("No data available to export");
                this.loaderService.hide();
                return;
            }
            const excelList = [];
            this.excelColumns = [
                'MessagingType',
                'Recipient',
                'Status',
                'Message'
            ]

            exportData.forEach((a, index) => {
                excelList.push({
                    "MessagingType": a.messagingTypeString,
                    "Recipient": this.encryptionname(a.messagingNameString),
                    "Status": a.messageStatusTypeString,
                    "Message": a.message
                });
            });
            this.excelService.exportAsExcelFile(excelList, "HomeConnectMessaging_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
            this.loaderService.stop();
        }, 500);
    }

    getRow(item) {
        var message = "";
        if (item.notificationType == this.MessageNotificationTypeEnum.HtmlEMail) {
            var temparray = item.message.split('Kind');
            var temp = document.createElement("div");
            temp.innerHTML = temparray[0];
            message = temp.textContent || temp.innerText || "";
        }
        else {
            message = item.message;
        }
        return [
            item.messagingTypeString,
            item.notificationTypeString,
            item.messagingRecipientString,
            item.messageStatusTypeString,
            message
        ];
    }
    

}
